import "./scss/newsletter-texcotton.scss"

import { Form } from "../../components/Form"
import type { WidgetAppProps, WidgetProps } from "../../types/widget.props"

export function WidgetTexCotton({ configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    return (
        <div className="news-texcotton widget-cadastro-news flex justify-center">
            <div className="news-area flex column align-center">
                <h2 className="title">{textosPersonalizados.newsletterTitle}</h2>
                <span className="sub-title">{textosPersonalizados.newsletterDescription}</span>
                <Form
                    configuracaoSite={configuracaoSite}
                    textosPersonalizados={textosPersonalizados}
                    dinformname="newsletter-widget-texcotton"
                    className={{
                        form: "flex",
                        button: "button"
                    }}
                />
            </div>
        </div>
    )
}

export default class WidgetTexCottonApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<WidgetTexCotton {...props} />)
    }
}